import Axios from 'axios';
var IncomeOrderService = (function () {
    function IncomeOrderService() {
    }
    IncomeOrderService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/incomeorder/list', { params: params });
    };
    IncomeOrderService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get('supplierclientapi/supplierdepot/get_options', { params: params });
    };
    IncomeOrderService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post('supplierclientapi/suppliergoods/stockinit_goodslist', params);
    };
    IncomeOrderService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/incomeorder/detail', { params: params });
    };
    IncomeOrderService.prototype.audit = function (params) {
        return Axios.get('supplierclientapi/incomeorder/audit', { params: params });
    };
    IncomeOrderService.prototype.cancel = function (params) {
        return Axios.get('supplierclientapi/incomeorder/cancel', { params: params });
    };
    IncomeOrderService.prototype.save = function (params) {
        return Axios.post('supplierclientapi/incomeorder/save', params);
    };
    IncomeOrderService.createInstance = function () {
        IncomeOrderService.getInstance();
    };
    IncomeOrderService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    IncomeOrderService.prototype.incomeExport = function (params) {
        return Axios.get("supplierclientapi/incomeorder/export_detail", { params: params });
    };
    return IncomeOrderService;
}());
export default IncomeOrderService;
